import React, { useState } from "react";
import DeleteAccountHeader from "./DeleteAccountHeader";
import EnterNumber from "./EnterNumber";
import OtpVerify from "./OtpVerify";
import ConfirmationPage from "./ConfirmationPage";
import "./DeleteAccount.css";

const DeleteAccount = () => {
  const [page, setPage] = useState(0);
  const [phoneNo, setphoneNo] = useState("");
  return (
    <>
      <DeleteAccountHeader />
      {page != 2 && (
        <div className="wrapper_v2">
          <div class="boxWhite deleteSection">
            <h5>You’re about to delete your account</h5>
            <p>
              All the data associated with it (including your profile, car
              details, package details, saved address) will be permanently
              deleted. This information can’t be recovered once the account is
              deleted.
            </p>

            {page == 0 && (
              <EnterNumber
                setPage={setPage}
                phoneNo={phoneNo}
                setphoneNo={setphoneNo}
              />
            )}
            {page == 1 && <OtpVerify setPage={setPage} phoneNo={phoneNo} />}
          </div>
        </div>
      )}
      {page == 2 && <ConfirmationPage />}
    </>
  );
};

export default DeleteAccount;
